import { Modal } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';

import { DeleteTerminalProps } from './DeleteTerminal.types';
import * as Styled from './DeleteTerminal.styles';

export const DeleteTerminal = ({
  selectedTerminal,
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
  cannotDelete,
}: DeleteTerminalProps) => {
  const { formatMessage } = useLocale();

  return (
    <>
      <Styled.TrashIcon onClick={onModalOpen} style={{ cursor: 'pointer' }} />

      <Modal
        header={formatMessage({
          id: AppMessages['definitions.display.delete.title'],
        })}
        open={isModalOpen}
        onClose={onModalClose}
        submitButtonDisabled={isLoading}
        onSubmit={cannotDelete ? onModalClose : onSubmit}
        submitButtonText={formatMessage({ id: AppMessages[cannotDelete ? 'common.ok' : 'common.delete'] })}
        size={cannotDelete ? 'medium' : 'small'}
        type={cannotDelete ? 'info' : 'form'}
      >
        {cannotDelete ? (
          <>
            <Styled.CannotDeleteErrorText>
              {formatMessage({ id: AppMessages['definitions.display.delete.error.cannotDelete'] })}
            </Styled.CannotDeleteErrorText>

            <Styled.CannotDeleteErrorText>
              {formatMessage({ id: AppMessages['definitions.display.delete.error.message'] })}
            </Styled.CannotDeleteErrorText>
          </>
        ) : (
          <>
            <ActionModal.Subtitle>{selectedTerminal.nazwa}</ActionModal.Subtitle>

            <ActionModal.Text>{formatMessage({ id: AppMessages['definitions.display.delete.text'] })}</ActionModal.Text>

            <ActionModal.Text>{formatMessage({ id: AppMessages['common.irreversibleAction'] })}</ActionModal.Text>
          </>
        )}
      </Modal>
    </>
  );
};
